var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_17165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_17165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3952 1.5C16.0402 1.5 16.6857 1.73774 17.1901 2.21597C18.2325 3.20619 18.2741 4.85351 17.2833 5.89529L11.4551 12.0182L17.2773 18.0987C18.2718 19.1368 18.2353 20.7842 17.1956 21.778C16.1554 22.7719 14.5067 22.7349 13.5122 21.6963L5.9723 13.8234C5.01114 12.8195 5.00931 11.2384 5.96636 10.2313L13.5058 2.30906C14.0188 1.77197 14.7054 1.5 15.3952 1.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackWhite);
export default __webpack_public_path__ + "static/media/arrow-back-white.93c49fcf9279551f7cbade3537a9358a.svg";
export { ForwardRef as ReactComponent };